import ExtendedSpine from "slotworks/graphics/spine/spine";
import { SpineSequenceSchema } from "slotworks/config/spine-config-schema";
import * as PIXI from 'pixi.js';
import particleManager from "slotworks/graphics/particles/particle-manager";
import Point from "slotworks/utils/geom/point";

export default class SpineSequence {
    
    protected spine: ExtendedSpine;
    protected schema: SpineSequenceSchema;

    protected tracks: Map<string, number> = new Map();
    protected track: number;

    private particles: Map<string, number> = new Map<string, number>();

    public container: PIXI.Container;

    constructor(spine: ExtendedSpine, schema: SpineSequenceSchema) {
        this.spine = spine;
        this.schema = schema;

        this.track = 0;

        this.container = new PIXI.Container();
        this.container.addChild(this.spine as any);
    }

    public play() {
        for(const event of this.schema.events) {
            if(event.string == "on" || event.string == "off") {
                setTimeout(() => {
                    const emitter = this.getParticle(event.name, event.background);
                    emitter.emit = event.string == "on";
                }, event.time ? event.time * 1000 : 0);
            } else if(event.string == "play" || event.string == "loop") {
                setTimeout(() => {
                    this.spine.state.setAnimation(this.track, event.name, event.string == "loop");
                    this.tracks.set(event.name, this.track);
                    this.track++;
                }, event.time ? event.time * 1000 : 0);
            } else if(event.string == "stop") {
                setTimeout(() => {
                    const track = this.tracks.get(event.name);
                    this.spine.state.clearTrack(track);
                }, event.time ? event.time * 1000 : 0);
            }
        }
    }

    public stop() {

    }

    public destroy() {

    }

    protected getParticle(particleId: string, background: boolean = false) {
        if(!this.particles.has(particleId)) {
            const particleContainer = new PIXI.Container();
            const particle = particleManager.add(particleId, new Point(0, 0), particleContainer);

            this.particles.set(particleId, particle);
            if(background)
                this.container.addChildAt(particleContainer, 0);
            else
                this.container.addChild(particleContainer);
        }

        return particleManager.get(this.particles.get(particleId));
    }
}


// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/graphics/spine/spine-sequence.ts